import React from "react";
import { Link } from "react-router-dom";
import SubcategoryList from "../../components/Master/SubCategoryList";


const SubCategoryList = () => {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Subcategory List</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Master</li>
          <li>Subcategory List</li>
        </ul>
      </div>

      <SubcategoryList />
    </>
  );
}
export default SubCategoryList;
